import {Instance, types} from 'mobx-state-tree';
import {AuctionTypeEnum, AuctionAccessTypeEnum} from '@joyrideautos/auction-core/src/types/AuctionTypes';

export const AuctionFormat = types.enumeration([AuctionTypeEnum.SEQUENCE, AuctionTypeEnum.LISTING]);
export type AuctionFormatType = Instance<typeof AuctionFormat>;

export const AuctionAccess = types.enumeration([AuctionAccessTypeEnum.PUBLIC, AuctionAccessTypeEnum.RESTRICTED]);
export type AuctionAccessType = Instance<typeof AuctionAccess>;
